import { RootState } from '@/app/stores'
import { 
    getJobApplications, 
    getVacancies,
    IJobApplication, 
    IJobOpening, 
} from '@/shared/api/employment'
import { ErrorType } from '@/shared/types'
import { createAsyncThunk } from '@reduxjs/toolkit'
import { AxiosError } from 'axios'

export const fetchVacancies = createAsyncThunk<
    IJobOpening[],
    void,
    { state: RootState }
>('employment/fetchVacancies', async (_, thunkAPI) => {
    try {
        const data = await getVacancies()
        return data.data
    } catch (err: unknown) {
        const knownError = err as AxiosError<ErrorType>

        return thunkAPI.rejectWithValue({
            message: knownError.response?.data?.message,
            error_id: knownError.response?.data?.error_id
        })
    }
})

export const fetchJobApplications = createAsyncThunk<
    IJobApplication[],
    void,
    { state: RootState }
>('employment/fetchJobApplications', async (_, thunkAPI) => {
    try {
        const status = thunkAPI.getState().employment.selectedApplicationStatus
        const data = await getJobApplications(status)
        return data.data
    } catch (err: unknown) {
        const knownError = err as AxiosError<ErrorType>

        return thunkAPI.rejectWithValue({
            message: knownError.response?.data?.message,
            error_id: knownError.response?.data?.error_id
        })
    }
})